import React from 'react';
import { Icon } from './Icon.js';
export const IconHighlighter = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9.5 8.08203L9.5 3.5L14 2H14.5V8.08203", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M4 16H20", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M4 21L4 15.5L7 12L7.8 8.57618C10.5078 7.55999 13.4922 7.55999 16.2 8.57618L17 12L20 15.5V21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconHighlighter.js.map